import { VCard } from 'vuetify/lib/components/VCard';
import { VOverlay } from 'vuetify/lib/components/VOverlay';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "search-bar", attrs: { "data-qa": "search-bar" } },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "form",
            {
              staticClass: "search-bar__container",
              style: { zIndex: _setup.isDialogVisible ? 5 : undefined },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _setup.handleSubmitForm.apply(null, arguments)
                },
              },
            },
            [
              _c(_setup.SearchInput, {
                ref: "input",
                staticClass: "search-bar__input",
                attrs: {
                  placeholder: `Врачи, клиники, услуги в ${_setup.context.town.name_pred}`,
                },
                on: {
                  click: _setup.handleClickSearchInput,
                  focus: _setup.handleFocusSearchInput,
                  submit: _setup.handleSubmitForm,
                },
                nativeOn: {
                  keydown: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp",
                        ])
                      )
                        return null
                      $event.preventDefault()
                      return _setup.handleKeydownArrowUp.apply(null, arguments)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown",
                        ])
                      )
                        return null
                      $event.preventDefault()
                      return _setup.handleKeydownArrowDown.apply(
                        null,
                        arguments
                      )
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape",
                        ])
                      )
                        return null
                      $event.preventDefault()
                      return _setup.handleKeydownEsc.apply(null, arguments)
                    },
                  ],
                },
                model: {
                  value: _setup.query,
                  callback: function ($$v) {
                    _setup.query = $$v
                  },
                  expression: "query",
                },
              }),
              _vm._v(" "),
              !_setup.isMobile && _setup.isDialogVisible
                ? _c("div", { staticClass: "search-bar__dropdown-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "overflow-hidden rounded-sm" },
                      [
                        _c(
                          VCard,
                          {
                            staticClass: "search-bar__dropdown",
                            attrs: { rounded: "sm" },
                          },
                          [
                            _c(_setup.SearchResults, {
                              ref: "searchResults",
                              attrs: {
                                query: _setup.query,
                                town: _setup.town,
                                "is-office-ip": _setup.context.is_office_ip,
                                "x-space-class": "px-4",
                              },
                              on: {
                                "activate-dropdown-item":
                                  _setup.handleActivateDropdownItem,
                                "deactivate-dropdown-item":
                                  _setup.handleDeactivateDropdownItem,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          !_setup.isMobile
            ? _c(VOverlay, {
                attrs: { opacity: 0, "z-index": "1" },
                on: { click: _setup.handleClickOverlay },
                model: {
                  value: _setup.isDialogVisible,
                  callback: function ($$v) {
                    _setup.isDialogVisible = $$v
                  },
                  expression: "isDialogVisible",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }